import { useEffect, useState } from 'react';
import { GetEmployeeLeavesApi } from '../redux/lms/apiRoute';

const useGetEmpLeave = (id, page = 1, limit = 1, moduleType) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetch = async () => {
      setLoading(true);
      try {
        let params = new URLSearchParams();
        params.append('page', page);
        params.append('limit', limit);
        params.append('moduleType', moduleType);
        const res = await GetEmployeeLeavesApi(params, id);
        if (res?.statusCode == 200) {
          setOptions(res?.data?.leaves);
        } else setError(res?.message || 'Something went wrong');
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    if (id) fetch();
  }, [id]);

  return { leaves: options, loading, error };
};

export default useGetEmpLeave;
